import { createFileRoute } from '@tanstack/react-router';
import { ExpressSignup } from '@/components/express';

// A Consultant's Express link. Open to everyone: signed out it makes an account, signed in a new campaign.
export const Route = createFileRoute('/express/$code')({
  component: ExpressLinkPage,
});

function ExpressLinkPage() {
  const { code } = Route.useParams();
  return <ExpressSignup code={code} />;
}
